@let kbControls = form().controls.kbItems.controls;
@let canEdit = canEditKb$ | async;

<form [formGroup]="form()">
    <fieldset>
        <legend
            class="form-label h6 fw-bold d-flex align-items-center justify-content-between"
        >
            <span i18n>Knowledge base items</span>
            @if (canEdit) {
            <la-icon-button
                [icon]="faPlus"
                iconPosition="right"
                size="sm"
                label="Add knowledge base item"
                (click)="addKnowledgeBaseItem()"
                i18n-label
                outline
            />
            }
        </legend>
    </fieldset>

    <ul class="ps-0 list-unstyled" formArrayName="kbItems">
        @for (kbItem of kbControls; let i = $index; track
        `${i}-${kbItem.value.entity1}-${kbItem.value.relationship}-${kbItem.value.entity2}`)
        {
        <li class="mb-3">
            @if (canEdit) {
            <div [formGroupName]="i" class="input-group">
                <input
                    type="text"
                    class="form-control"
                    formControlName="entity1"
                    placeholder="Entity 1"
                    required
                />
                <select class="form-select" formControlName="relationship">
                    <option value="" disabled selected i18n>
                        Select relationship
                    </option>
                    @for (relationship of relationshipTypes; track $index) {
                    <option [value]="relationship">
                        {{ getRelationshipTypeName(relationship) }}
                    </option>
                    }
                </select>
                <input
                    type="text"
                    class="form-control"
                    formControlName="entity2"
                    placeholder="Entity 2"
                    required
                />
                <la-icon-button
                    buttonStyle="danger"
                    [icon]="faTrash"
                    label="Remove"
                    (click)="removeKnowledgeBaseItem(i)"
                    visuallyHiddenLabel
                    i18n-label
                />
            </div>
            } @else {
            <p class="form-control-plaintext">
                "{{ kbItem.controls.entity1.value }}"
                {{
                    getRelationshipTypeName(kbItem.controls.relationship.value)
                }}
                "{{ kbItem.controls.entity2.value }}"
            </p>
            }
        </li>
        } @empty {
        <li class="text-muted" i18n>
            No knowledge base items defined for this problem.
        </li>
        }
    </ul>
</form>
